import { authHeader, authKioskHeader, ApiConfigs } from '../_helpers';
import {userService} from "@/_services/user.service";

export const kioskService = {
    getAll,
    getPage,
    filter,
    getById,
    update,
    create,
    resetPassword,
    delete: _delete,
    login,
    logout,
    findCustomerByPhoneNumber,
    createCustomer,
    getQueueById,
    joinQueue,
    refresh,
    sendLoginRequest,
    getKioskPings,
    sendRefreshRequest,
    sendLogoutRequest,
    goToV1,
    goToV2
};


function getAll() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.getAll}&mode=lite`, requestOptions).then(handleResponse);
}


function getPage(page) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.pagination+page}`, requestOptions).then(handleResponse);
}


function filter(keyword) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.filter.replace(':keyword', keyword)}`, requestOptions).then(handleResponse);
}


function getById(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authHeader()
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.get.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function update(id, kiosk) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: kiosk
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.update.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function resetPassword(id) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: {}
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.resetPassword.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function create(kiosk) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader() },
        body: kiosk
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.create}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        credentials : 'include',
        headers: authHeader()
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks._delete.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function findCustomerByPhoneNumber(phone) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(phone)
    };

    return fetch(`${ApiConfigs.base_kiosk_url+ApiConfigs.kiosks.findCustomerByPhone}`, requestOptions).then(handleResponse);
}

function createCustomer(customer) {
    const requestOptions = {
        method: 'PUT',
        credentials : 'include',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(customer)
    };

    return fetch(`${ApiConfigs.base_kiosk_url+ApiConfigs.kiosks.createCustomer}`, requestOptions).then(handleResponse);
}

function joinQueue(data) {
    const requestOptions = {
        method: 'PUT',
        credentials : 'include',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };

    return fetch(`${ApiConfigs.base_kiosk_url+ApiConfigs.kiosks.joinQueue}`, requestOptions).then(handleResponse);
}

function login(key, secret) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, secret })
    };

    return fetch(`${ApiConfigs.base_kiosk_url+ApiConfigs.kiosks.login}`, requestOptions)
    .then(handleResponse)
    .then(kiosk => {
        // login successful if there's a jwt token in the response
        if (kiosk.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('kiosk', JSON.stringify(kiosk));
        }
        return kiosk;
    });
}

function logout() {
    // remove user from local storage to log user out
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(`${ApiConfigs.base_kiosk_url+ApiConfigs.kiosks.logout}`, requestOptions)
    .then(handleResponse)
    .then(function () {
        localStorage.removeItem('kiosk');
    });
}

function getQueueById(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: authKioskHeader()
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.queues.get.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function refresh() {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authKioskHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(`${ApiConfigs.base_kiosk_url+ApiConfigs.kiosks.refresh}`, requestOptions)
        .then(handleResponse)
        .then(kiosk => {
            localStorage.setItem('kiosk', JSON.stringify(kiosk));
            return kiosk;
        });
}

function sendLoginRequest(id, payload) {
    const requestOptions = {
        method: 'POST',
        credentials : 'include',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.sendLoginRequest.replace(':id', id)}`, requestOptions).then(handleResponse);
}


function getKioskPings(payload) {
    
    const requestOptions = {
      method: 'POST',
      credentials : 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI4IiwianRpIjoiYTU4MGI3YmViZmY1OTA1MmE3YjJlZWY3YmM5NjNjOGZmMzRmYTBkNjRhMTdmNDk0YzJiMjhkZDcyODY0N2RhMDllNmFmOWE4ZjhiMzcxMjciLCJpYXQiOjE2ODAyNzA1MDMuNTIxNjk4LCJuYmYiOjE2ODAyNzA1MDMuNTIxNzAyLCJleHAiOjE3MTE4OTI5MDMuNTE5Mzk4LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.li7D2lKmCf6s3dmjj4LyPddvG4Qz_58GZFHyxs8pZTstbp0E2FTvUuChKy53jxoc1dlGKkQiG241PWlRz0uCSYOs7dlm8Ph2rimU_6QI5hgJRXcp9dg72iPZMjjSPEylPXGrpsPbF2rdg8TjkxgBBDZ_qhUz6hpinKh3IhI-tyyweqy1wRvKPQNenNIeCZ9aISnyKQ0zDTaH1oYiGNzu8tZ6DmCkp4yhXpamhu9clmuMHSOQwZ6v9NNFw55O8gmJmp3JVq5xAus3bQUcThKaq1vcMD-L0s8mj_O96hb2ZppwfOWe17FQ8eVmTIXgiaWLBcu1xPsQ8iMN4CXogbGVZHRY0R1hJkYdwaCiYkpAHcROidbKu74YUUq9wlK1VtIG3mEixpsTJsC8Yj6Sdf_znnX-vUn5sBKWDj4mlIGwUsXZm-Htio437Qjgiw7CqwZD1u236Jf1w31BHd8k9japXnkIGuzXHRjIyYtRhXgzt-_c1KJXbhhkvvoDdf5MyvQQ3OEskyhuf6v7p-gMFjYsPEoVsUrxlHvFjHPd4Fk9QvtGqUskjlWwPuw4b-rcIJCMpK3zqrb62To9Si_T7lkLhexn2Wq8EQB_-K6g6citkAMZNmcceH8V79xcl6-nbPU1EYs7zLQF5srHlSN7UdTyi3rv3EiJ2KjyvBP0BWGdB6w'},
        body: JSON.stringify(payload)
    };    
    return fetch('https://api-staging.liberrex.com/v1/admin/kiosks/pings', requestOptions).then(handleResponse);

    
}

function goToV1(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() }
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.gotToV1.replace(':id', id)}`, requestOptions).then(handleResponse);
}
function goToV2(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() }
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.gotToV2.replace(':id', id)}`, requestOptions).then(handleResponse);
}
function sendRefreshRequest(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() }
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.sendRefreshRequest.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function sendLogoutRequest(id) {
    const requestOptions = {
        method: 'GET',
        credentials : 'include',
        headers: { ...authHeader() }
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.kiosks.sendLogoutRequest.replace(':id', id)}`, requestOptions).then(handleResponse);
}



function handleResponse(response) {
    return response.text().then(text => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 403) {
                // auto logout if 401 response returned from api
                if(localStorage.getItem('user')){
                    userService.logout();
                }
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}